import Slider from './slider';

export default class InlineSlider extends Slider {
    constructor(element, options, navigation) {
        super(element, options);

        this.navigation = document.querySelector(navigation);

        if (this.navigation) {
            this.initEventListeners();
        }
    }

    initEventListeners() {
        this.handleSliderLock();
        this.swiper.on('setTranslate', this.handleSliderLock.bind(this));
        this.swiper.on('resize', this.handleSliderLock.bind(this));
    }

    handleSliderLock() {
        if (this.swiper.isLocked) {
            this.navigation.classList.remove('visible');
        } else if (!this.navigation.classList.contains('visible')) {
            this.navigation.classList.add('visible');
        }
    }
}
